import { useId, type InputHTMLAttributes } from 'react';
import { cn } from './cn';

export function Champ({
  libelle,
  erreur,
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { libelle: string; erreur?: string | undefined }) {
  const id = useId();
  const idErreur = `${id}-erreur`;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-[13px] font-medium">
        {libelle}
      </label>
      <input
        id={id}
        aria-invalid={erreur ? true : undefined}
        aria-describedby={erreur ? idErreur : undefined}
        className={cn(
          'h-10 rounded-[10px] border border-border bg-surface px-3 text-sm text-ink placeholder:text-faint',
          'focus:border-primary focus:ring-3 focus:ring-primary-subtle focus:outline-none',
          erreur && 'border-danger-border',
          className
        )}
        {...props}
      />
      {erreur ? (
        <p id={idErreur} className="text-xs text-danger">
          {erreur}
        </p>
      ) : null}
    </div>
  );
}
